import { render } from "./App.vue?vue&type=template&id=26e1c52d"
const script = {}

import "./App.vue?vue&type=style&index=0&id=26e1c52d&lang=css"
script.render = render

export default script